import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-64a8a066")

_pushScopeId("data-v-64a8a066")
const _hoisted_1 = { class: "p-grid p-m-0" }
const _hoisted_2 = { class: "table-header p-d-flex p-ai-center" }
const _hoisted_3 = {
  id: "search-container",
  class: "p-input-icon-left p-mr-3"
}
const _hoisted_4 = /*#__PURE__*/_createVNode("i", { class: "pi pi-search" }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Button = _resolveComponent("Button")
  const _component_Toolbar = _resolveComponent("Toolbar")
  const _component_Message = _resolveComponent("Message")
  const _component_InputText = _resolveComponent("InputText")
  const _component_Column = _resolveComponent("Column")
  const _component_DataTable = _resolveComponent("DataTable")
  const _component_DocumentExecutionSnapshotDialog = _resolveComponent("DocumentExecutionSnapshotDialog")
  const _directive_tooltip = _resolveDirective("tooltip")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--primary p-col-12" }, {
      start: _withId(() => [
        _createTextVNode(_toDisplayString(_ctx.$t('documentExecution.main.scheduledExecutions')), 1)
      ]),
      end: _withId(() => [
        _createVNode(_component_Button, {
          id: "document-execution-schedulations-close-button",
          class: "kn-button kn-button--primary",
          onClick: _ctx.closeTable
        }, {
          default: _withId(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('common.close')), 1)
          ]),
          _: 1
        }, 8, ["onClick"])
      ]),
      _: 1
    }),
    _createVNode(_component_DataTable, {
      value: _ctx.schedulations,
      id: "old-chedulations-table",
      class: "p-datatable-sm kn-table p-col-12",
      dataKey: "id",
      filters: _ctx.filters,
      "onUpdate:filters": _cache[2] || (_cache[2] = ($event: any) => (_ctx.filters = $event)),
      globalFilterFields: _ctx.documentExecutionSchedulationsTableDescriptor.globalFilterFields,
      paginator: _ctx.schedulations.length > 20,
      rows: 20,
      responsiveLayout: "stack",
      breakpoint: "600px"
    }, {
      empty: _withId(() => [
        _createVNode(_component_Message, {
          class: "p-m-2",
          severity: "info",
          closable: false,
          style: _ctx.documentExecutionSchedulationsTableDescriptor.styles.message
        }, {
          default: _withId(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('common.info.noDataFound')), 1)
          ]),
          _: 1
        }, 8, ["style"])
      ]),
      header: _withId(() => [
        _createVNode("div", _hoisted_2, [
          _createVNode("span", _hoisted_3, [
            _hoisted_4,
            _createVNode(_component_InputText, {
              class: "kn-material-input",
              modelValue: _ctx.filters['global'].value,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.filters['global'].value = $event)),
              type: "text",
              placeholder: _ctx.$t('common.search')
            }, null, 8, ["modelValue", "placeholder"])
          ])
        ])
      ]),
      default: _withId(() => [
        _createVNode(_component_Column, {
          class: "kn-truncated",
          field: "name",
          header: _ctx.$t('common.name'),
          key: "name",
          sortable: true
        }, null, 8, ["header"]),
        _createVNode(_component_Column, {
          class: "kn-truncated",
          field: "description",
          header: _ctx.$t('common.description'),
          key: "description",
          sortable: true
        }, null, 8, ["header"]),
        _createVNode(_component_Column, {
          class: "kn-truncated",
          field: "dateCreation",
          header: _ctx.$t('common.creationDate'),
          key: "dateCreation",
          sortable: true
        }, {
          body: _withId((slotProps) => [
            _createTextVNode(_toDisplayString(_ctx.getFormattedDate(slotProps.data.dateCreation, 'DD/MM/YYYY hh:mm')), 1)
          ]),
          _: 1
        }, 8, ["header"]),
        _createVNode(_component_Column, {
          style: _ctx.documentExecutionSchedulationsTableDescriptor.iconColumn.style
        }, {
          body: _withId((slotProps) => [
            _withDirectives(_createVNode(_component_Button, {
              icon: "pi pi-download",
              class: "p-button-link",
              onClick: ($event: any) => (_ctx.downloadSnapshot(slotProps.data))
            }, null, 8, ["onClick"]), [
              [
                _directive_tooltip,
                _ctx.$t('common.download'),
                void 0,
                { top: true }
              ]
            ]),
            _createVNode(_component_Button, {
              icon: "pi pi-trash",
              class: "p-button-link",
              onClick: ($event: any) => (_ctx.deleteSchedulationConfirm(slotProps.data))
            }, null, 8, ["onClick"])
          ]),
          _: 1
        }, 8, ["style"])
      ]),
      _: 1
    }, 8, ["value", "filters", "globalFilterFields", "paginator"]),
    _createVNode(_component_DocumentExecutionSnapshotDialog, {
      visible: _ctx.snapshotDialogVisible,
      propUrl: _ctx.url,
      onClose: _cache[3] || (_cache[3] = ($event: any) => (_ctx.snapshotDialogVisible = false))
    }, null, 8, ["visible", "propUrl"])
  ]))
})